import { atlassianTheme } from './atlassian-theme';
import { type NavigationTheme } from './types';

/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */
export const defaultTheme: NavigationTheme = atlassianTheme;

export { atlassianTheme } from './atlassian-theme';
